export const key = 'StateCurrent';
export const setStateCurrentType = 'SET_STATE_CURRENT_TYPE';